import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Phone, Mail, MapPin, MessageCircle, Clock, Facebook, Instagram } from "lucide-react";

export default function ContactPage() {
    const [s, setS] = useState(null);
    useEffect(() => {
        api.get("/settings").then((r) => setS(r.data)).catch(() => {});
    }, []);

    if (!s) return <div className="max-w-7xl mx-auto px-4 py-20 text-center font-mono text-sm">Cargando…</div>;

    const wa = (s.whatsapp || "").replace(/[^0-9]/g, "");
    const waLink = wa ? `https://wa.me/${wa}` : null;

    return (
        <div data-testid="contact-page">
            <section className="hero-blueprint text-white">
                <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
                    <span className="lz-section-label">Visítanos</span>
                    <h1 className="font-display text-5xl md:text-7xl font-bold uppercase tracking-tight">Contacto</h1>
                    <p className="mt-4 max-w-2xl text-white/70">Estamos para ayudarte con tu proyecto. Llámanos, escríbenos o visítanos en sucursal.</p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-4 py-16 grid lg:grid-cols-3 gap-6">
                {s.phone && (
                    <a href={`tel:${s.phone}`} className="border-2 border-[var(--lz-navy)] p-6 hover:bg-[var(--lz-orange)] transition-colors" data-testid="contact-card-phone">
                        <Phone className="w-6 h-6 text-[var(--lz-orange)] group-hover:text-[var(--lz-navy)]" />
                        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--lz-navy)]/60 mt-3">Teléfono</div>
                        <div className="font-display text-2xl font-bold uppercase mt-1">{s.phone}</div>
                    </a>
                )}
                {waLink && (
                    <a href={waLink} target="_blank" rel="noreferrer" className="border-2 border-[var(--lz-navy)] p-6 hover:bg-[var(--lz-orange)] transition-colors" data-testid="contact-card-wa">
                        <MessageCircle className="w-6 h-6 text-[var(--lz-orange)]" />
                        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--lz-navy)]/60 mt-3">WhatsApp</div>
                        <div className="font-display text-2xl font-bold uppercase mt-1">Escríbenos</div>
                    </a>
                )}
                {s.email && (
                    <a href={`mailto:${s.email}`} className="border-2 border-[var(--lz-navy)] p-6 hover:bg-[var(--lz-orange)] transition-colors" data-testid="contact-card-email">
                        <Mail className="w-6 h-6 text-[var(--lz-orange)]" />
                        <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--lz-navy)]/60 mt-3">Email</div>
                        <div className="font-display text-xl font-bold uppercase mt-1 break-all">{s.email}</div>
                    </a>
                )}
            </section>

            <section className="max-w-7xl mx-auto px-4 pb-16 grid lg:grid-cols-2 gap-8">
                <div className="border-2 border-[var(--lz-navy)] p-6">
                    <span className="lz-section-label">Sucursal</span>
                    <h2 className="font-display text-3xl font-bold uppercase">Ubicación</h2>
                    <div className="flex gap-3 items-start mt-5">
                        <MapPin className="w-5 h-5 text-[var(--lz-orange)] mt-0.5" />
                        <div>
                            <div className="font-bold">{s.address}</div>
                            <div className="text-sm text-[var(--lz-navy)]/70">{s.city}</div>
                            {s.map_url && (
                                <a href={s.map_url} target="_blank" rel="noreferrer" className="lz-btn lz-btn-outline mt-4 !py-2 text-xs" data-testid="open-map">
                                    Abrir en Maps
                                </a>
                            )}
                        </div>
                    </div>
                    {(s.facebook || s.instagram) && (
                        <div className="mt-6 pt-6 border-t border-[var(--lz-navy)]/15">
                            <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[var(--lz-navy)]/60 mb-2">Redes</div>
                            <div className="flex gap-2">
                                {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" className="p-2 border border-[var(--lz-navy)] hover:bg-[var(--lz-orange)]"><Facebook className="w-4 h-4" /></a>}
                                {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" className="p-2 border border-[var(--lz-navy)] hover:bg-[var(--lz-orange)]"><Instagram className="w-4 h-4" /></a>}
                            </div>
                        </div>
                    )}
                </div>

                <div className="border-2 border-[var(--lz-navy)] bg-[var(--lz-navy)] text-white p-6">
                    <span className="text-xs font-bold uppercase tracking-[0.3em] text-[var(--lz-orange)]">Atención</span>
                    <h2 className="font-display text-3xl font-bold uppercase mt-1">Horario</h2>
                    <div className="mt-5 space-y-2">
                        {(s.hours || []).map((h) => (
                            <div key={`${h.day}-${h.time}`} className="flex justify-between border-b border-white/10 pb-2 font-mono">
                                <span className="flex items-center gap-2"><Clock className="w-4 h-4 text-[var(--lz-orange)]" /> {h.day}</span>
                                <span>{h.time}</span>
                            </div>
                        ))}
                    </div>
                    {s.about && <p className="mt-6 text-sm text-white/70">{s.about}</p>}
                </div>
            </section>
        </div>
    );
}
